import _ from "lodash";
import {sortAlphaNumeric} from "../../../utils";

export const columns = (options, filters, sorter) => {
  const data = [
    {
      title: "Id/Кампания",
      dataIndex: "campaignIdAndName",
      sorter: true,
      fixed: "left"
    },
    {
      title: "Тип кaмпании",
      dataIndex: "campaignType",
      sorter: true
    },
    {
      title: "Количество попыток дозвона",
      dataIndex: "callAttempts",
      sorter: true,
    },
    {
      title: "Id/Номер абонента",
      dataIndex: "msisdn",
      sorter: true,
    },
    {
      title: "Длительность звонка",
      dataIndex: "callDuration",
      sorter: true,
    },
    {
      title: "Статус звонка",
      dataIndex: "dialingStatus",
      sorter: true,
    },
    {
      title: "Дата и время начала звонка",
      dataIndex: "startedAt",
      sorter: true,
    },
    {
      title: "Дата и время завершения звонка",
      dataIndex: "endAt",
      sorter: true,
    },
    {
      title: "Общее количество попыток дозвона",
      dataIndex: "dialed",
      sorter: true,
    },
    {
      title: "АОН кампании",
      dataIndex: "aon",
      sorter: true,
    },
    {
      title: "Id/Оператор",
      dataIndex: "operator_msisdn",
      sorter: true,
    },
    {
      title: "Запись разговора",
      dataIndex: "callRecord",
      sorter: true,
    },
  ];

  if (options) {
    Object.keys(options).forEach((dataIndex) => {
      const index = _.findIndex(data, { dataIndex });
      if (index !== -1) data[index] = { ...data[index], ...options[dataIndex] };
    });
  }

  if (filters) {
    Object.keys(filters).forEach((dataIndex) => {
      const index = _.findIndex(data, { dataIndex });
      if (index !== -1 && filters[dataIndex])
        data[index].filteredValue = filters[dataIndex];
    });
  }

  if (sorter) {
    Object.keys(sorter).forEach((dataIndex) => {
      const index = _.findIndex(data, { dataIndex });
      if (index !== -1 && sorter[dataIndex]) {
        data[index].sortOrder = sorter[dataIndex];
        data[index].sorter = (a, b) => {
          return sortAlphaNumeric(a[dataIndex], b[dataIndex]);
        };
      }
    });
  }

  return data;
}
